import {} from './addContext.types';
export const addContext = (context) => (t) => ({
    transport: async (messages) => {
        t.transport(messages.map((m) => ({ ...m, context })));
    },
});
